export default __webpack_public_path__ + "static/media/whatsapp.8218cde4.mp3";